import { render } from "./FollowCamPage.vue?vue&type=template&id=494f4f5d"
import script from "./FollowCamPage.vue?vue&type=script&lang=js"
export * from "./FollowCamPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Threejs\\VuejsThreejsForDemo-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__